"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestBuilder = void 0;
const snakecase_keys_1 = __importDefault(require("snakecase-keys"));
class RequestBuilder {
    constructor(eventName, metadata) {
        this.tableName = eventName;
        this.event = metadata;
    }
    appendEventMetadata(metadata) {
        this.event = Object.assign(Object.assign({}, this.event), metadata);
    }
    validate() {
        return this.isTableNameSnakeCased(this.tableName) && this.isFlat(this.event);
    }
    getRequest() {
        return {
            tableName: this.tableName,
            event: this.event,
        };
    }
    toString() {
        return JSON.stringify(snakecase_keys_1.default(this.getRequest()));
    }
    isFlat(event) {
        const haveNestedObject = (Object.keys(event).some((prop) => {
            const value = event[prop];
            return Array.isArray(value) || typeof value === 'object';
        }));
        if (haveNestedObject) {
            throw new Error('Can\'t save nested objects');
        }
        return true;
    }
    isTableNameSnakeCased(tableName) {
        const snakeCasePattern = new RegExp('^([a-z][a-z0-9]*)(_[a-z0-9]+)*$');
        if (!tableName.match(snakeCasePattern)) {
            const snakeCasedTableName = tableName.toLowerCase().replace(/\s/g, '_');
            throw Error(`Invalid event name. Maybe '${snakeCasedTableName}'?`);
        }
        return true;
    }
}
exports.RequestBuilder = RequestBuilder;
